import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export const Card = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
	<div className={cn("rounded-md border border-line bg-surface p-5", className)} {...props} />
);

export const CardTitle = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => (
	<h2 className={cn("text-sm font-medium tracking-tight text-ink", className)} {...props} />
);

export const CardValue = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => (
	<p className={cn("mt-2 text-2xl font-semibold tracking-tight text-ink", className)} {...props} />
);

export const CardHint = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => (
	<p className={cn("mt-1 text-xs text-ink-muted", className)} {...props} />
);
